export const INJECTION_ERRORS = {
  TIMEOUT_DEVICE_RESPOND: 1,
  TIMEOUT_PREPARING: 5,
  SHUT_DOWN: 2,
  NOT_FOUND: 3,
  GENERAL: 4,
  CANCELLED: 6,
  OTHER_STARTED: 7,
  PRESSURE_BOUNDARIES: 8,
  SLOW_PRESSURE_GROW: 9, // unused
  CONFIGURATION_CHANGED: 10,
  NOT_ENOUGH_SOLVENT: 11,
  UNABLE_TO_WASH_NEEDLE_AFTER_INJECTION: 12,
  SHAKING_ERROR: 13,
  HARDWARE_GET_READY_TIMEOUT: 14,
  PRESSURE_NOT_REACHED_BEFORE_MIN_VOLUME: 15,
  AUTOSAMPLER_LOOP_WASH_ERROR: 16,
  REACH_MIN_PRESSURE_ERROR: 17,
  PRESSURE_ALIGN_ERROR: 18, // unused
  START_PUMP_GENERAL_ERROR: 19,
  GRADIENT_TABLE_NOT_FOUND: 20,
  UNKNOWN_PUMP_TYPE: 21,
  CANCELLED_BY_SERVER: 22,
  INVALID_CONFIGURATION: 23,
  HARDWARE_COMPONENT_FAULT: 24,
  DOMP_OPERATION_FAILED: 25,
  HARDWARE_COMMAND_ERROR: 26,
  HARDWARE_UNEXPECTED_OPERATION_FLOW: 27,
  CANCELLED_BY_HARDWARE: 28,
  NOT_ENOUGH_SOLVENT_RECOVER_AFTER_RUN: 29,
  VIAL_NOT_PRESENT: 30,
} as const;

export const INJECTION_ERROR_MESSAGES: Record<
  typeof INJECTION_ERRORS[keyof typeof INJECTION_ERRORS],
  string
> = {
  [INJECTION_ERRORS.TIMEOUT_DEVICE_RESPOND]: "The Device didn't responded",
  [INJECTION_ERRORS.TIMEOUT_PREPARING]: 'Preparing took longer than expected',
  [INJECTION_ERRORS.SHUT_DOWN]: 'The Device shut down while running',
  [INJECTION_ERRORS.NOT_FOUND]: 'The injection cannot be restored',
  [INJECTION_ERRORS.GENERAL]: 'General error',
  [INJECTION_ERRORS.CANCELLED]: 'Stopped by user',
  [INJECTION_ERRORS.OTHER_STARTED]: 'Another run started',
  [INJECTION_ERRORS.PRESSURE_BOUNDARIES]: 'Pressure outside min-max limits',
  [INJECTION_ERRORS.SLOW_PRESSURE_GROW]: 'Unable to reach pressure in time',
  [INJECTION_ERRORS.CONFIGURATION_CHANGED]: 'Configuration changed',
  [INJECTION_ERRORS.NOT_ENOUGH_SOLVENT]: 'Not enough solvent to execute',
  [INJECTION_ERRORS.UNABLE_TO_WASH_NEEDLE_AFTER_INJECTION]: 'Unable to wash needle after injection',
  [INJECTION_ERRORS.SHAKING_ERROR]: 'Shake before injection error',
  [INJECTION_ERRORS.HARDWARE_GET_READY_TIMEOUT]: 'Unable to get hardware ready',
  [INJECTION_ERRORS.PRESSURE_NOT_REACHED_BEFORE_MIN_VOLUME]:
    'Unable to build pressure before minimum pump volume was reached',
  [INJECTION_ERRORS.AUTOSAMPLER_LOOP_WASH_ERROR]: 'Unable to wash loop',
  [INJECTION_ERRORS.REACH_MIN_PRESSURE_ERROR]: 'Unable to reach min pressure',
  [INJECTION_ERRORS.PRESSURE_ALIGN_ERROR]: 'Unable to align pressure',
  [INJECTION_ERRORS.START_PUMP_GENERAL_ERROR]: 'Pump general error',
  [INJECTION_ERRORS.GRADIENT_TABLE_NOT_FOUND]: 'Gradient table is not found',
  [INJECTION_ERRORS.UNKNOWN_PUMP_TYPE]: 'Unknown pump type',
  [INJECTION_ERRORS.CANCELLED_BY_SERVER]: 'Cancelled by server',
  [INJECTION_ERRORS.INVALID_CONFIGURATION]: 'Invalid configuration',
  [INJECTION_ERRORS.HARDWARE_COMPONENT_FAULT]: 'Hardware component fault',
  [INJECTION_ERRORS.DOMP_OPERATION_FAILED]: "Hardware module didn't respond",
  [INJECTION_ERRORS.HARDWARE_COMMAND_ERROR]: 'Hardware module sent an unexpected response',
  [INJECTION_ERRORS.CANCELLED_BY_HARDWARE]: 'Cancelled by hardware',
  [INJECTION_ERRORS.HARDWARE_UNEXPECTED_OPERATION_FLOW]: 'Hardware unexpected operation flow',
  [INJECTION_ERRORS.NOT_ENOUGH_SOLVENT_RECOVER_AFTER_RUN]:
    'Not enough solvent to recover after run',
  [INJECTION_ERRORS.VIAL_NOT_PRESENT]: 'Vial not present',
} as const;
